import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/prospectsAndCustomersSagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import Filters from "./smartComponents/Filters";
import CardsList from "./smartComponents/CardsList";

import "./prospectsAndCustomers.scss";

const ProspectsAndCustomersModule = (props) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.prospectsCustomers.isLoading);
  const isUpdating = useSelector((state) => state.prospectsCustomers.isUpdating);
  const initialRequest = useSelector((state) => state.prospectsCustomers.initialRequest);

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchInitialData(props));
    }
  }, []);

  return (
    <SectionToggle
      isLoading={isLoading}
      title="Prospects & Customers"
      autoHeight
      content={
        <div id="prospects-and-customers">
          <Filters />
          {isUpdating ? <LoadingAnimation text="Updating data..." /> : <CardsList />}
        </div>
      }
    />
  );
};

export default ProspectsAndCustomersModule;
